import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { KlarTilGodkendelseViewModel } from '@store/models';

@Injectable({
    providedIn: 'root'
})
export class RegnskabsaarTilGodkendelseService {

    constructor(
        private http: HttpClient
    ) { }

    getRegnskabsaarTilGodkendelseView() {
        const url = `[api]/v2kundeaccept/KlarTilGodkendelseByUser/[userid]`;
        return this.http.get<KlarTilGodkendelseViewModel[]>(url);
    }
}
